export const setCookie = (name: string, value: string, time: number) => {
  const date = new Date();

  date.setTime(date.getTime() + time);

  const expires = date.toUTCString();

  document.cookie = [
    `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
    `expires=${expires}`,
    'path=/',
    'SameSite=Strict',
    ...(window.location.protocol === 'https:' ? ['Secure'] : []),
  ].join(';');
};

export const getCookie = (name: string): string | null => {
  const encodedName = encodeURIComponent(name);
  const cookie = document.cookie
    .split(';')
    .find((c) => c.trim().startsWith(`${encodedName}=`));

  if (!cookie) {
    return null;
  }

  // Cookies are found as name=value... remove name=
  return decodeURIComponent(
    cookie.trim().substring(encodedName.length + 1, cookie.length),
  );
};

export const deleteCookie = (name: string) => {
  setCookie(name, '', -1);
};
